import { render, staticRenderFns } from "./recipeComments.vue?vue&type=template&id=a75dd066&"
import script from "./recipeComments.vue?vue&type=script&lang=js&"
export * from "./recipeComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports